/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum GenderBundle {
    MALE = 'Male',
    FEMALE = 'Female',
    DIVERSE = 'Diverse',
}
